import React from 'react';
import Stars from './Stars';
import './styles/Reviews.css';

const Reviews = (props) => {
    return (
        <div>
            <div className="review__block">
                <h2>{props.username}</h2>
                <h4>{props.time}</h4>
                <Stars rating={props.rating} />
                <p>{props.comment}</p>
            </div>
        </div>
    );
};

export default Reviews;